import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import App from './App';
createRoot(document.getElementById('root')).render(_jsx(App, {}));
